import React from 'react';
import { FieldCheckbox } from '.';
import { FieldCheckboxWithReduxProps } from './types';

export function FieldCheckboxWithRedux({
  input: { name, onChange, value },
  ...props
}: FieldCheckboxWithReduxProps) {
  return (
    <FieldCheckbox {...props} name={name} onChange={onChange} value={value} />
  );
}
